import { render } from "./DocumentDetails.vue?vue&type=template&id=04a05f59&scoped=true"
import script from "./DocumentDetails.vue?vue&type=script&lang=js"
export * from "./DocumentDetails.vue?vue&type=script&lang=js"

import "./DocumentDetails.vue?vue&type=style&index=0&id=04a05f59&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a05f59"]])

export default __exports__